// Stash the Flow C consult identity (`appointmentId` + the patient's `manage_token`)
// across the Stripe Checkout redirect, same idiom as `lib/pendingBooking.js` and for the
// same reason: `POST /api/consults/{id}/intents`' `return_path` (gateway-api-contract.md
// §2) is a plain path — "/merci/consultation" — with no room for query params the
// backend does not already own, so the return page (`CheckoutSuccess.jsx`, kind
// "consultation") cannot recover the appointment/token pair from the URL alone. Written
// right before the redirect (`ConsultBooking.jsx`) and read on the way back. NOT cleared
// on arrival: the return page IS the consultation room, so a reload of it re-reads this
// stash, and clearing on mount made any refresh lose the room permanently. It expires on
// its own TTL and is overwritten by the next booking.
const KEY = "solunary_pending_consult";
// TWELVE HOURS, and it is sized for the CONSULTATION, not for the redirect. The stash
// used to live one hour, which comfortably covered the Stripe hop — but
// `/merci/consultation` is where `ConsultRoomFrame` mounts, so the stash is also what a
// RELOAD of the room reads. A consult may run to the 60-minute cap, and a refresh after
// the old TTL found nothing: no room, no heartbeat, and with the billable terminal taken
// as the earlier party's last-seen, the whole span pinned to the instant the patient's
// tab died. Twelve hours covers any consultation plus the browsing around it, and a new
// booking overwrites this same single key, so a stale entry cannot shadow a live one.
const TTL_MS = 12 * 60 * 60 * 1000;

export function writePendingConsult({ appointmentId, token }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ appointmentId, token, until: Date.now() + TTL_MS }));
  } catch (e) { /* storage unavailable: proceed to Stripe anyway */ }
}

export function readPendingConsult() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p?.appointmentId || !p?.token || !p?.until || Date.now() > p.until) {
      localStorage.removeItem(KEY);
      return null;
    }
    return p;
  } catch (e) {
    return null;
  }
}

export function clearPendingConsult() {
  try { localStorage.removeItem(KEY); } catch (e) { /* already gone */ }
}
